import { SerializedStyles, css } from "@emotion/react"
import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"
import { Flex } from "rebass"
import { BodySubtextNormal, BodyTextSemibold } from "./typography/text"

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  backgroundColor: string
  icon: IconDefinition
  color: string
  title: string
  subTitle?: string
  additionalStyling?: SerializedStyles
}

const infoboxTextContainerStyle = css`
  flex-direction: column;
  gap: 8px;
  align-items: start;
`

export const InfoBox = ({
  backgroundColor,
  icon,
  color,
  title,
  subTitle,
  additionalStyling,
  onClick,
  ...rest
}: Props) => {
  const infoboxStyle = css`
    flex-direction: row;
    padding: 16px;
    border-radius: 4px;
    gap: 16px;
    width: 100%;
    align-items: ${!subTitle ? "center" : ""};
    cursor: ${onClick ? "pointer" : ""};
    background-color: ${backgroundColor};
    ${additionalStyling}
  `

  return (
    <Flex css={infoboxStyle} onClick={onClick} {...rest}>
      <FontAwesomeIcon icon={icon} color={color} />
      <Flex css={infoboxTextContainerStyle}>
        <BodyTextSemibold color={color}>{title}</BodyTextSemibold>
        {subTitle && (
          <BodySubtextNormal color={color}>{subTitle}</BodySubtextNormal>
        )}
      </Flex>
    </Flex>
  )
}
